import { render, staticRenderFns } from "./OtherProblemsSection.vue?vue&type=template&id=485ed662&scoped=true&"
import script from "./OtherProblemsSection.vue?vue&type=script&lang=js&"
export * from "./OtherProblemsSection.vue?vue&type=script&lang=js&"
import style0 from "./OtherProblemsSection.vue?vue&type=style&index=0&id=485ed662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ed662",
  null
  
)

export default component.exports